import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthGuard } from './services/auth.guard';
import { AuthService } from './services/authentication.service';

@NgModule({
  imports: [
  ],
  providers: [
    AuthService,
    AuthGuard
  ]
})
export class AuthModule  {

  constructor(@Optional() @SkipSelf() parentModule: AuthModule) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Auth module in the AppModule only.`);
    }
  }

}
